import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { Text } from '../../text';
import { classNames } from "../../../utils/helpers";
import s from './Label.module.css';
export const Label = ({ text, attributes, className, disabled, required, htmlFor = text, shifted, variant = 'floating', truncate = false, }) => {
    const rootClassName = classNames(s.root, disabled && s['--disabled'], required && s['--required'], shifted && s['--shifted'], truncate && s['--truncate'], s[`--variant-${variant}`], className);
    return (_jsx(Text, { as: "label", className: rootClassName, attributes: Object.assign(Object.assign({}, attributes), { htmlFor }), children: text }));
};
